<template>
  <div class="payment-adapt-container">
    <div class="param-danger" style="background:#fff1f0;border:1px solid #ffa39e;color:#cf1322;border-radius:6px;padding:8px 12px;margin-bottom:12px;font-size:13px;line-height:1.6;">
      <b>⚠ 危险参数配置页，请勿随意修改！</b><br>
      本页是<u>支付厂家字典</u>（payment_adapt），定义各支付厂家的代码实现（Spring Bean）。
      修改或新增厂家必须与后端实际存在的支付实现类对应，填错会导致业主端支付、退款失败。
      非平台开发 / 运维人员请勿改动；如需新增厂家，先与开发确认。
    </div>
    <el-card class="search-wrapper">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('paymentAdapt.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="searchForm.name" :placeholder="$t('paymentAdapt.vendorName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-select v-model="searchForm.statusCd" :placeholder="$t('paymentAdapt.status')" clearable style="width:100%">
            <el-option :label="$t('paymentAdapt.enabled')" value="0" />
            <el-option :label="$t('paymentAdapt.disabled')" value="1" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">{{ $t('paymentAdapt.search') }}</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="list-wrapper">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('paymentAdapt.title') }}</span>
        <el-button type="primary" size="small" style="float:right" @click="handleAdd">
          {{ $t('paymentAdapt.add') }}
        </el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width:100%">
        <el-table-column prop="name" :label="$t('paymentAdapt.vendorName')" align="center" />
        <el-table-column prop="paymentType" :label="$t('paymentAdapt.vendorType')" align="center" />
        <el-table-column prop="beanJsapi" :label="$t('paymentAdapt.beanJsapi')" align="center" show-overflow-tooltip />
        <el-table-column prop="beanQrcode" :label="$t('paymentAdapt.beanQrcode')" align="center" show-overflow-tooltip />
        <el-table-column prop="beanNative" :label="$t('paymentAdapt.beanNative')" align="center" show-overflow-tooltip />
        <el-table-column :label="$t('paymentAdapt.status')" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.statusCd === '0' ? 'success' : 'danger'">
              {{ scope.row.statusCd === '0' ? $t('paymentAdapt.enabled') : $t('paymentAdapt.disabled') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('paymentAdapt.createTime')" align="center" />
        <el-table-column :label="$t('paymentAdapt.operation')" align="center" width="230">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="openKeyManage(scope.row)">
              {{ $t('paymentAdapt.keyManage') }}
            </el-button>
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">
              {{ $t('paymentAdapt.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
              {{ $t('paymentAdapt.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>

    <add-payment-adapt ref="addDialog" @success="fetchList" />
    <payment-key-manage ref="keyDialog" />
  </div>
</template>

<script>
import { listPaymentAdapt, deletePaymentAdapt } from '@/api/system/paymentAdaptApi'
import AddPaymentAdapt from '@/components/system/addPaymentAdapt'
import PaymentKeyManage from '@/components/system/paymentKeyManage'

export default {
  name: 'PaymentAdaptList',
  components: {
    AddPaymentAdapt,
    PaymentKeyManage
  },
  data() {
    return {
      loading: false,
      searchForm: {
        name: '',
        statusCd: ''
      },
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          page: this.page.current,
          row: this.page.size
        }
        const res = await listPaymentAdapt(params)
        this.tableData = res.data || []
        this.page.total = res.total || 0
      } catch (error) {
        console.error('Failed to fetch payment adapts:', error)
        this.$message.error(error.message || '获取支付厂家失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page.current = 1
      this.fetchList()
    },
    handleSizeChange(size) {
      this.page.size = size
      this.fetchList()
    },
    handleCurrentChange(page) {
      this.page.current = page
      this.fetchList()
    },
    handleAdd() {
      this.$refs.addDialog.open(null)
    },
    handleEdit(row) {
      this.$refs.addDialog.open(row)
    },
    openKeyManage(row) {
      this.$refs.keyDialog.open(row)
    },
    handleDelete(row) {
      this.$confirm(this.$t('paymentAdapt.confirmDelete'), this.$t('common.confirm'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        try {
          await deletePaymentAdapt({ adaptId: row.adaptId })
          this.$message.success(this.$t('common.deleteSuccess'))
          this.fetchList()
        } catch (error) {
          this.$message.error(error.message || this.$t('common.deleteFail'))
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-adapt-container {
  .search-wrapper, .list-wrapper {
    margin-bottom: 20px;
  }
}
</style>
